module.exports = function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/v-debounce/debounce.js
// module id = 512
// module chunks = 0